export const COVERAGES = [
  'Commercial Auto Liability',
  'Cargo',
  'Physical Damage',
  'General Liability',
  'Cyber',
  'Workers Compensation',
]
